import moment from 'moment'
import { Timestamp } from '@/interfaces/Timestamp'

/**
 * 格式化日期。
 * @param timestamp
 * @param format
 */
export const formatDate = (timestamp: Timestamp, format?: string | null) => {
	if (!format) {
		format = 'YYYY-MM-DD HH:mm:ss'
	}

	if (!timestamp) return ''

	if (timestamp.$date == 0) return ''

	return moment(timestamp.$date).format(format)
}

/**
 * 计算时间戳之间的差值
 * @param start_time 开始时间戳
 * @param end_time 结束时间戳
 */
export const calculateDiffTime = (start_time: number, end_time: number) => {
	var startTime = 0,
		endTime = 0

	console.log(start_time, end_time)
	if (start_time < end_time) {
		startTime = start_time
		endTime = end_time
	} else {
		startTime = end_time
		endTime = start_time
	}

	var timeDiff = endTime - startTime
	console.log('timeDiff', timeDiff)

	// //计算天数

	// var year = Math.floor(timeDiff / 86400 / 365);

	// timeDiff = timeDiff % (86400 * 365);

	// var month = Math.floor(timeDiff / 86400 / 30);

	// timeDiff = timeDiff % (86400 * 30);

	// var day = Math.floor(timeDiff / 86400);

	// timeDiff = timeDiff % 86400;

	// var hour = Math.floor(timeDiff / 3600);

	// timeDiff = timeDiff % 3600;

	// var minute = Math.floor(timeDiff / 60);

	// timeDiff = timeDiff % 60;

	// var second = timeDiff;

	// return [year, month, day, hour, minute, second]

	var hour = Math.floor(timeDiff / 3600)

	timeDiff = timeDiff % 3600

	var minute = Math.floor(timeDiff / 60)

	timeDiff = timeDiff % 60

	var second = timeDiff

	return [hour, minute, second]
}

/**
 *
 * @param numb
 * @param format
 */
export const formatExcelDate = (numb: number, format = '-') => {
	const time = new Date((numb - 1) * 24 * 3600000 + 1)
	time.setFullYear(time.getFullYear() - 70)
	const year = time.getFullYear()
	const month = time.getMonth() + 1
	const date = time.getDate()
	if (format && format.length === 1) {
		return year + format + month + format + date
	}
	return year + (month < 10 ? '0' + month : month.toString()) + (date < 10 ? '0' + date : date.toString())
}

/**
 *
 * @param numb
 * @param format
 */
export const formatExcelDateTime = (numb: number, format = '-') => {
	const time = new Date((numb - 1) * 24 * 3600000 + 1)
	time.setFullYear(time.getFullYear() - 70)
	const year = time.getFullYear()
	const month = time.getMonth() + 1
	const date = time.getDate()
	const hour = time.getHours()
	const minutes = time.getMinutes()
	const seconds = time.getSeconds()

	if (format && format.length === 1) {
		return year + format + month + format + date + ' ' + (hour < 10 ? '0' + hour : hour.toString()) + ':' + minutes + ':' + seconds
	}

	return year + (month < 10 ? '0' + month : month.toString()) + (date < 10 ? '0' + date : date.toString()) + ' ' + hour + ':' + minutes + ':' + seconds
}
